// TeacherPlaygroundPythonIDE.js

import TeacherPythonIDEWrapper from "../../../components/IDEs/wrappers/teacher/TeacherPythonIDEWrapper";

const TeacherPlaygroundPythonIDE = () => {
  return <TeacherPythonIDEWrapper type="playground" />;
};

export default TeacherPlaygroundPythonIDE;
